import { ENGINE_MATCHER_LESS } from '../../logger/constants';
export function lessThanEqualMatcherContext(log, ruleAttr) {
    return function lessThanEqualMatcher(runtimeAttr) {
        var isLessEqualThan = runtimeAttr <= ruleAttr;
        log.debug(ENGINE_MATCHER_LESS, [runtimeAttr, ruleAttr, isLessEqualThan]);
        return isLessEqualThan;
    };
}
